import { atom, getDefaultStore } from 'jotai';

export type PerfDebugLogEntry = {
  timestamp: number;
  type: 'start' | 'checkpoint' | 'finish' | 'cancel' | 'abandoned';
  key: string;
  detail?: string;
  elapsedMs?: number;
};

export const perfDebugLogAtom = atom<PerfDebugLogEntry[]>([]);

const isDebugEnabled = process.env.NEXT_PUBLIC_PERF_DEBUG === 'true';

const MAX_DEBUG_LOG_ENTRIES = 500;

let storeInstance: ReturnType<typeof getDefaultStore> | null = null;

function getStore(): ReturnType<typeof getDefaultStore> | null {
  if (storeInstance) return storeInstance;
  try {
    storeInstance = getDefaultStore();
    return storeInstance;
  } catch {
    return null;
  }
}

export function pushDebugLog(entry: Omit<PerfDebugLogEntry, 'timestamp'>): void {
  if (!isDebugEnabled) return;
  const store = getStore();
  if (!store) return;

  const prev = store.get(perfDebugLogAtom);
  const newEntry = { ...entry, timestamp: Date.now() };
  const next = [...prev.slice(-(MAX_DEBUG_LOG_ENTRIES - 1)), newEntry];
  store.set(perfDebugLogAtom, next);
}
